/* eslint-disable react/no-danger */

import { sanitizeHTML } from "@/utils/sanitize-html";

interface HtmlContentProps {
  html: string;
  className?: string;
}

export const HtmlContent = ({ html, className }: HtmlContentProps) => {
  return (
    <p
      className={className}
      dangerouslySetInnerHTML={{
        __html: sanitizeHTML(html),
      }}
    />
  );
};
